import imageOnboarding2 from '../../assets/image-onboarding-2.webp';
import { ProgressIndicators } from '../progress-indicators';
import { OnboardingContinueButton } from '../onboarding-continue-button';
import { OnboardingScreen } from '../onboarding-layout';

interface Step3Props {
  onContinue: () => void;
}

export function OnboardingStep3({ onContinue }: Step3Props) {
  return (
    <OnboardingScreen
      slot="onboarding-step-3"
      header={
        <div className="flex w-full flex-col items-center gap-3">
          <ProgressIndicators currentStep={2} />

          <div className="w-full text-center">
            <h1 className="font-display text-[28px] font-bold leading-9 text-mf-neutral-900">
              File once, and we&apos;ll handle everything after that
            </h1>
            <p className="mt-2 text-base leading-5 text-mf-neutral-600">
              We track every deadline and status update automatically, so you don&apos;t have to
            </p>
          </div>
        </div>
      }
      footer={<OnboardingContinueButton onClick={onContinue} />}
    >
      <div className="flex min-h-0 w-full flex-1 flex-col justify-center">
        <div className="mx-auto flex min-h-0 w-full max-w-[384px] flex-1 flex-col justify-center max-h-[320px]">
          <img
            src={imageOnboarding2}
            alt=""
            className="h-full min-h-0 w-full object-contain object-bottom"
          />
        </div>
      </div>
    </OnboardingScreen>
  );
}
